// Generated by psc version 0.10.2
"use strict";
var $foreign = require("/Users/ropilz/Workspace/purs-2048/src/h2048.js");
var Prelude = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Prelude.purs");
var Data_Array = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-arrays/src/Data/Array.purs");
var Control_Monad_Eff = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-eff/src/Control/Monad/Eff.purs");
var Control_Monad_Eff_Console = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-console/src/Control/Monad/Eff/Console.purs");
var Control_Monad_Eff_Random = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-random/src/Control/Monad/Eff/Random.purs");
var Control_Monad_Eff_Unsafe = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-eff/src/Control/Monad/Eff/Unsafe.purs");
var Data_Foldable = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-foldable-traversable/src/Data/Foldable.purs");
var Data_List = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-lists/src/Data/List.purs");
var Data_Maybe = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-maybe/src/Data/Maybe.purs");
var Data_String = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-strings/src/Data/String.purs");
var Data_Tuple = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-tuples/src/Data/Tuple.purs");
var Data_Semigroup = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Semigroup.purs");
var Data_List_Types = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-lists/src/Data/List/Types.purs");
var Data_Function = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Function.purs");
var Control_Bind = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Bind.purs");
var Data_Eq = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Eq.purs");
var Data_Semiring = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Semiring.purs");
var Data_Boolean = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Boolean.purs");
var Data_Ring = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Ring.purs");
var Data_Functor = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Functor.purs");
var Control_Semigroupoid = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Semigroupoid.purs");
var Data_Ord = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Ord.purs");
var Control_Applicative = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Applicative.purs");
var Data_Unit = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Unit.purs");
var Up = (function () {
    function Up() {

    };
    Up.value = new Up();
    return Up;
})();
var Down = (function () {
    function Down() {

    };
    Down.value = new Down();
    return Down;
})();
var Left = (function () {
    function Left() {

    };
    Left.value = new Left();
    return Left;
})();
var Right = (function () {
    function Right() {

    };
    Right.value = new Right();
    return Right;
})();
var showRow = function (r) {
    return Data_String.joinWith("")(Data_Array.fromFoldable(Data_List_Types.foldableList)(Data_List.mapMaybe(function (i) {
        return Data_Maybe.Just.create($foreign.printf(5)(i));
    })(r)));
};
var replicate = function (l) {
    return function (a) {
        return Data_List.fromFoldable(Data_Foldable.foldableArray)(Data_Array.replicate(l)(a));
    };
};
var printGrid = function (grid) {
    return function __do() {
        $foreign.clearConsole();
        return $foreign.log(Data_String.joinWith("\n")(Data_Array.fromFoldable(Data_List_Types.foldableList)(Data_List.mapMaybe(function (r) {
            return Data_Maybe.Just.create(showRow(r));
        })(grid))))();
    };
};
var moves = (function () {
    var keys = function (chars) {
        return Data_List.zip(chars)(Data_List.fromFoldable(Data_Foldable.foldableArray)([ Up.value, Left.value, Down.value, Right.value ]));
    };
    return Data_Semigroup.append(Data_List_Types.semigroupList)(keys(Data_List.fromFoldable(Data_Foldable.foldableArray)([ "w", "a", "s", "d" ])))(keys(Data_List.fromFoldable(Data_Foldable.foldableArray)([ "c", "h", "t", "n" ])));
})();
var merge = function (xs) {
    var combine = function (v) {
        if (v instanceof Data_List_Types.Cons && v.value1 instanceof Data_List_Types.Cons) {
            if (v.value0 === v.value1.value0) {
                return new Data_List_Types.Cons(v.value0 * 2 | 0, combine(v.value1.value1));
            };
            if (Data_Boolean.otherwise) {
                return new Data_List_Types.Cons(v.value0, combine(new Data_List_Types.Cons(v.value1.value0, v.value1.value1)));
            };
        };
        return v;
    };
    var merged = combine(Data_List.filter(Data_Eq.notEq(Data_Eq.eqInt)(0))(xs));
    var padding = replicate(Data_List.length(xs) - Data_List.length(merged))(0);
    return Data_Semigroup.append(Data_List_Types.semigroupList)(merged)(padding);
};
var move = function (v) {
    if (v instanceof Left) {
        return Data_Functor.map(Data_List_Types.functorList)(merge);
    };
    if (v instanceof Right) {
        return Data_Functor.map(Data_List_Types.functorList)(function ($43) {
            return Data_List.reverse(merge(Data_List.reverse($43)));
        });
    };
    if (v instanceof Up) {
        return function ($44) {
            return Data_List.transpose(move(Left.value)(Data_List.transpose($44)));
        };
    };
    if (v instanceof Down) {
        return function ($45) {
            return Data_List.transpose(move(Right.value)(Data_List.transpose($45)));
        };
    };
    throw new Error("Failed pattern match at Main line 68, column 1 - line 68, column 23: " + [ v.constructor.name ]);
};
var matchMove = function (key) {
    return function (v) {
        return key === v.value0;
    };
};
var gridIndex = function (index) {
    return function (grid) {
        return Data_Maybe.fromMaybe(Data_List.range(0)(3))(Data_List.index(grid)(index));
    };
};
var setSquare = function (grid) {
    return function (v) {
        return function (val) {
            var pre = Data_List.take(v.value0)(grid);
            var post = Data_List.drop(v.value0 + 1 | 0)(grid);
            var mid = Data_Semigroup.append(Data_List_Types.semigroupList)(Data_Semigroup.append(Data_List_Types.semigroupList)(Data_List.take(v.value1)(gridIndex(v.value0)(grid)))(Data_List.fromFoldable(Data_Foldable.foldableArray)([ val ])))(Data_List.drop(v.value1 + 1 | 0)(gridIndex(v.value0)(grid)));
            return Data_Semigroup.append(Data_List_Types.semigroupList)(Data_Semigroup.append(Data_List_Types.semigroupList)(pre)(Data_List.fromFoldable(Data_Foldable.foldableArray)([ mid ])))(post);
        };
    };
};
var gridCoord = function (v) {
    return function (grid) {
        return Data_Maybe.fromMaybe(0)(Data_List.index(gridIndex(v.value0)(grid))(v.value1));
    };
};
var getZeroes = function (grid) {
    var singleRow = function (n) {
        return Data_List.zip(replicate(4)(n))(Data_List.range(0)(3));
    };
    var coordinates = Data_List.concatMap(singleRow)(Data_List.range(0)(3));
    return Data_List.filter(function (coord) {
        return gridCoord(coord)(grid) === 0;
    })(coordinates);
};
var isMoveLeft = function (grid) {
    var directions = Data_List.fromFoldable(Data_Foldable.foldableArray)([ Left.value, Right.value, Up.value, Down.value ]);
    var allChoices = Data_Functor.map(Data_List_Types.functorList)(function ($46) {
        return Data_List.length(getZeroes(Data_Function.flip(move)(grid)($46)));
    })(directions);
    return Data_Foldable.sum(Data_List_Types.foldableList)(Data_Semiring.semiringInt)(allChoices) > 0;
};
var chooseTuple = function (xs) {
    return function __do() {
        var v = Control_Monad_Eff_Random.randomInt(0)(Data_List.length(xs) - 1)();
        return Data_Maybe.fromMaybe(new Data_Tuple.Tuple(0, 0))(Data_List.index(xs)(v));
    };
};
var choose = function (xs) {
    return function __do() {
        var v = Control_Monad_Eff_Random.randomInt(0)(Data_List.length(xs) - 1)();
        return Data_Maybe.fromMaybe(0)(Data_List.index(xs)(v));
    };
};
var check2048 = function (grid) {
    return Data_Eq.notEq(Data_List_Types.eqList(Data_Eq.eqInt))(Data_List.fromFoldable(Data_Foldable.foldableArray)([  ]))(Data_List.filter(Data_Eq.eq(Data_Eq.eqInt)(2048))(Data_List.concat(grid)));
};
var captureMove = function (f) {
    return $foreign.getChar(function (c) {
        var $32 = Data_Foldable.find(Data_List_Types.foldableList)(matchMove(c))(moves);
        if ($32 instanceof Data_Maybe.Just) {
            var t = f($32.value0.value1);
            return Control_Applicative.pure(Control_Monad_Eff.applicativeEff)(t);
        };
        if ($32 instanceof Data_Maybe.Nothing) {
            return Control_Monad_Eff_Unsafe.unsafePerformEff(function __do() {
                $foreign.log("Use WASD or CHTN as input")();
                return captureMove(f);
            });
        };
        throw new Error("Failed pattern match at Main line 106, column 21 - line 112, column 29: " + [ $32.constructor.name ]);
    });
};
var newGrid = function (grid) {
    return function (f) {
        return captureMove(function (m) {
            var new_grid = f(move(m)(grid));
            return Data_Unit.unit;
        });
    };
};
var appendList = function (a) {
    return function (b) {
        return Data_List.concat(Data_List.fromFoldable(Data_Foldable.foldableArray)([ a, b ]));
    };
};
var addTile = function (grid) {
    var candidates = getZeroes(grid);
    return function __do() {
        var v = chooseTuple(candidates)();
        var v1 = choose(Data_List.fromFoldable(Data_Foldable.foldableArray)([ 2, 2, 2, 2, 2, 2, 2, 2, 2, 4 ]))();
        var new_grid = setSquare(grid)(v)(v1);
        return new_grid;
    };
};
var gameLoop = function (grid) {
    if (isMoveLeft(grid)) {
        return Control_Monad_Eff_Unsafe.unsafePerformEff(function __do() {
            printGrid(grid)();
            var $39 = check2048(grid);
            if ($39) {
                return $foreign.log("You won!")();
            };
            if (!$39) {
                return newGrid(grid)(function (new_grid) {
                    var $40 = Data_Eq.notEq(Data_List_Types.eqList(Data_List_Types.eqList(Data_Eq.eqInt)))(grid)(new_grid);
                    if ($40) {
                        return Control_Monad_Eff_Unsafe.unsafePerformEff(function __do() {
                            var v = addTile(new_grid)();
                            return gameLoop(v);
                        });
                    };
                    if (!$40) {
                        return gameLoop(grid);
                    };
                    throw new Error("Failed pattern match at Main line 151, column 15 - line 155, column 35: " + [ $40.constructor.name ]);
                })();
            };
            throw new Error("Failed pattern match at Main line 147, column 9 - line 155, column 36: " + [ $39.constructor.name ]);
        });
    };
    if (Data_Boolean.otherwise) {
        return Control_Monad_Eff_Unsafe.unsafePerformEff(function __do() {
            printGrid(grid)();
            return $foreign.log("Game over")();
        });
    };
    throw new Error("Failed pattern match at Main line 144, column 1 - line 160, column 1: " + [ grid.constructor.name ]);
};
var start = function __do() {
    var v = addTile(replicate(4)(Data_List.fromFoldable(Data_Foldable.foldableArray)([ 0, 0, 0, 0 ])))();
    addTile(v)();
    return v;
};
var main = (function () {
    var grid = Control_Monad_Eff_Unsafe.unsafePerformEff(start);
    return gameLoop(grid);
})();
module.exports = {
    main: main
};



//////////////////
// WEBPACK FOOTER
// ./h2048.purs
// module id = 109
// module chunks = 0